// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@guestsupply/XDL/Utilities/mergeWithCss";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { FC, useState } from "react";

export interface ProductDiscontinuedMessageProps {
    product?: ProductModel;
    extendedStyles?: DiscontinuedMessageStyle;
}

export interface DiscontinuedMessageStyle {
    messageWrapper?: TypographyPresentationProps;
    message?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

type Props = HasProductContext & ProductDiscontinuedMessageProps;

export const discontinuedMessageStyle: DiscontinuedMessageStyle = {};

const ProductDiscontinuedMessage: FC<Props> = ({ productContext: { product }, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(discontinuedMessageStyle, extendedStyles));
    if (!product.isDiscontinued) {
        return null;
    }
    return (
        <Typography {...styles.messageWrapper}>
            <Typography {...styles.message} aria-label="Discontinued">
                {translate("Discontinued")}
            </Typography>
            <Icon {...styles.icon}></Icon>
        </Typography>
    );
};

export default withProductContext(ProductDiscontinuedMessage);
